import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
}

export const useRequestUtbReport = () => {
  return useMutation({
    mutationFn: async ({ batchId }: HookProps) => {
      const result = await apiClient.batchesReports.generateUtbReport.mutation({ params: { id: batchId } });
      if (result.status !== 200) throw result.body;

      return result.body;
    },
    onSuccess: () => {
      toast.success('UTB report is being prepared. It will appear in the Reports menu once ready.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error requesting the UTB report!');
    },
  });
};
